import { Plus, PlusCircle, X, XCircle } from 'react-feather';
import { styled } from 'baseui';
import * as React from 'react';
import { colors } from '../../utils/styles';
export const PlusIconComp = styled((Plus as React.ComponentType<{}>), {
  verticalAlign: '-4px',
  color: colors.darkGrey
});
export const PlusIcon = (props: any) => <PlusIconComp {...props} size={18} />;
export const XIconComp = styled((X as React.ComponentType<{}>), {
  verticalAlign: '-4px',
  color: colors.darkGrey
});
export const XIcon = (props: any) => <XIconComp {...props} size={18} />;
export const PlusCircleIcon = styled((PlusCircle as React.ComponentType<{}>), {
  verticalAlign: '-7px',
  color: colors.darkGrey
});
export const XCircleIcon = styled((XCircle as React.ComponentType<{}>), {
  paddingLeft: '5px',
  verticalAlign: '-8px',
  color: colors.darkGrey,
  cursor: 'pointer'
});